import NavButtons from './NavButtons'

const Corkboard = ({ children, onScreenUpdate }) => {
  return (
    <div className="cboardWrap">
      <div className="corkboard">{children}</div>
      <NavButtons onScreenUpdate={onScreenUpdate} />
    </div>
  )
}

export default Corkboard
